module.exports = __webpack_public_path__ + "img/GrayOutline640.aac36595.png";